import { cn } from '@/utils/styles';
import { Button } from '@design-system/Button';
import { BookmarkIcon } from '@/components/icons/BookmarkIcon';
import { BookmarkFilledIcon } from '@/components/icons/BookmarkFilledIcon';
import { Loader2 } from "lucide-react";

interface BookmarkButtonProps
  extends React.ComponentPropsWithoutRef<typeof Button> {
  bookmarked?: boolean;
  isPending?: boolean;
}

export const BookmarkButton = ({
  children,
  className,
  bookmarked,
  isPending,
  disabled,
  ...rest
}: BookmarkButtonProps) => (
  <Button
    size="icon"
    variant="ghost"
    disabled={disabled || isPending}
    {...rest}
    className={cn(
      '[&_svg]:size-6',
      'relative',
      'cursor-default disabled:cursor-not-allowed',
      'disabled:opacity-50',
      'transition-opacity',
      className
    )}
  >
    {isPending ? (
      <Loader2 className="size-6 animate-spin" />
    ) : bookmarked ? (
      <BookmarkFilledIcon width={24} height={24} />
    ) : (
      <BookmarkIcon
        width={24}
        height={24}
        className="text-secondary-foreground"
      />
    )}
    {children}
  </Button>
);